import React from 'react';
import { Icon } from '@chakra-ui/react';

export const PolygonLogo = () => {
	return (
		<Icon
			width="10px"
			height="9px"
			viewBox="0 0 10 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.19321 2.55483C7.01958 2.45561 6.79634 2.45561 6.59791 2.55483L5.20888 3.37337L4.26632 3.89426L2.90209 4.71279C2.72846 4.81201 2.50522 4.81201 2.30679 4.71279L1.24021 4.06788C1.06658 3.96867 0.942559 3.77023 0.942559 3.547V2.30679C0.942559 2.10835 1.04178 1.90992 1.24021 1.7859L2.30679 1.1658C2.48042 1.06658 2.70366 1.06658 2.90209 1.1658L3.96867 1.8107C4.1423 1.90992 4.26632 2.10836 4.26632 2.33159V3.15013L5.20888 2.60444V1.7611C5.20888 1.56266 5.10966 1.36423 4.91123 1.24021L2.92689 0.0744125C2.75326 -0.0248042 2.53003 -0.0248042 2.33159 0.0744125L0.29765 1.26501C0.0992167 1.36423 0 1.56266 0 1.7611V4.09269C0 4.29112 0.0992167 4.48956 0.29765 4.61358L2.30679 5.77937C2.48042 5.87859 2.70366 5.87859 2.90209 5.77937L4.26632 4.98564L5.20888 4.43995L6.57311 3.64621C6.74674 3.547 6.96997 3.547 7.16841 3.64621L8.23499 4.26632C8.40862 4.36553 8.53264 4.56397 8.53264 4.78721V6.02741C8.53264 6.22585 8.43342 6.42428 8.23499 6.5483L7.19321 7.16841C7.01958 7.26762 6.79634 7.26762 6.59791 7.16841L5.53133 6.5483C5.3577 6.44909 5.23368 6.25065 5.23368 6.02741V5.23368L4.29112 5.77937V6.59791C4.29112 6.79634 4.39034 6.99478 4.58877 7.1188L6.59791 8.28459C6.77154 8.38381 6.99478 8.38381 7.19321 8.28459L9.20235 7.1188C9.37598 7.01958 9.5 6.82115 9.5 6.59791V4.24151C9.5 4.04308 9.40078 3.84465 9.20235 3.72063L7.19321 2.55483Z"
				fill="white"
			/>
		</Icon>
	);
};
